import { endpoints } from '../config'
import { getApiClient } from './api-client'

export async function getVenues(): Promise<Array<string>> {
  return getApiClient({ endpoint: endpoints.venues })
}
